<template>
    <div :class="[(form.errors.renter_report_share) ? '!border-2 !border-red-600 !shadow-md !shadow-red-500' : 'border border-gray-200','bg-white rounded-md shadow-sm mt-6']">
        <!-- Header Section -->
        <div class="sm:col-span-6 flex justify-between items-center border-b border-gray-200 py-4 px-6">
            <div>
                <h4 class="text-xl font-bold text-gray-700 sm:text-2xl">Renter Report Share Agreement</h4>
                <p class="text-sm text-gray-500 mt-1">Authorize sharing Credit History and Criminal Background Reports</p>
            </div>
            <div v-if="form.errors.renter_report_share">
                <font-awesome-icon :icon="faExclamationTriangle" size="2x" class="text-red-500" />
            </div>
        </div>
        
        <!-- Content Section -->
        <div class="p-6">
            <div class="bg-blue-50 rounded-lg p-4 mb-4">
                <p class="text-sm text-gray-700 leading-relaxed">
                    You understand that by clicking on the "I Agree" checkbox below, you are providing "written instructions" to RentRisk
                    under the Fair Credit Reporting Act authorizing RentRisk to obtain information from your personal credit report or other information from Experian.
                    You authorize RentRisk to obtain such information to confirm your identity, access and share your credit report and Vantage Score credit score with an
                    end user whom you have authorized to view your report and score for tenant screening purposes.
                </p>
            </div>
            
            <div class="mt-4">
                <label class="flex items-start space-x-3">
                    <input 
                        id="renter_report_share" 
                        type="checkbox" 
                        v-model="form.renter_report_share" 
                        :value="1"
                        class="mt-1 rounded border-gray-300 text-rent-risk-blue-400 focus:ring-rent-risk-blue-400 h-4 w-4" 
                    />
                    <span class="text-sm font-medium text-gray-700">
                        I agree to authorize RentRisk to access and share my credit report and background information
                    </span>
                </label>
                <p v-if="form.errors.renter_report_share" class="text-red-500 text-sm mt-2 ml-7">
                    {{ form.errors.renter_report_share }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';

export default {
    components: {
        FontAwesomeIcon
    },
    props: {
        form: Object,
        application: Object,
        states: Object,
        validateField: Function,
    },
    data() {
        return {
            faExclamationTriangle
        }
    },
}
</script>